export default "__VITE_ASSET__D6lDYn_$__"